module.exports = __webpack_public_path__ + "files/46a92369fcd71f2f274f6c7baf07ccfa.svg";